export const useFormatSyncDate = () => {
  const formatDateCallback = (date: Date | undefined) =>
    date
      ? `${date.toLocaleString(undefined, { dateStyle: 'long' })}, ${date.toLocaleString(undefined, {
          timeStyle: 'short',
        })}`
      : undefined;
  return { formatDate: formatDateCallback };
};
